import * as THREE from 'three';

export function CalculateSceneBounds(scene: THREE.Scene) {
	const sceneBounds = new THREE.Box3();
	scene.traverse(child=>{
		if (child["isMesh"] && (child.castShadow || child.receiveShadow)) {
			child.updateMatrixWorld(); // ensure up-to-date
			const objectBounds = new THREE.Box3().setFromObject(child, false); // use simpler bounds for perf?
			if (!objectBounds.isEmpty()) { // avoid empty bounds
				sceneBounds.union(objectBounds);
			}
		}
	});
	return sceneBounds;
}
export function CalculateSceneCorners(scene: THREE.Scene) {
	const box = CalculateSceneBounds(scene);
	return [
		new THREE.Vector3(box.min.x, box.min.y, box.min.z),
		new THREE.Vector3(box.max.x, box.min.y, box.min.z),
		new THREE.Vector3(box.min.x, box.max.y, box.min.z),
		new THREE.Vector3(box.max.x, box.max.y, box.min.z),
		new THREE.Vector3(box.min.x, box.min.y, box.max.z),
		new THREE.Vector3(box.max.x, box.min.y, box.max.z),
		new THREE.Vector3(box.min.x, box.max.y, box.max.z),
		new THREE.Vector3(box.max.x, box.max.y, box.max.z),
	];
}

export function UpdateCamBoundsToEncompassSceneBounds(
	dirLight: THREE.DirectionalLight,
	//shadowCam: THREE.PerspectiveCamera,
	//sceneBounds: THREE.Box3,
	worldCorners: THREE.Vector3[],
	padding = 5,
) {
	//const dirLight = self.dirLights[l];

	// --- Now, update shadow camera bounds for this light ---
	// the shadowCam is not part of the scene graph, so it has no parent-transform -- its "position"/orientation are in WORLD space.
	// the light (and its target) may live inside a rotated group (eg. the ZUpGroup), so we must use their WORLD positions here,
	// not the local .position fields (reading those directly made the light direction wrong for any non-identity parent transform).
	dirLight.updateWorldMatrix(true, false);
	dirLight.target.updateWorldMatrix(true, false);
	const lightWorldPos = dirLight.getWorldPosition(new THREE.Vector3());
	const targetWorldPos = dirLight.target.getWorldPosition(new THREE.Vector3());
	// DEBUG(lightmap): verify the effective light direction against what the scene graph actually gives
	if ((globalThis as any).lightmapDebug) {
		const dirWorld = targetWorldPos.clone().sub(lightWorldPos).normalize();
		console.log(`[LightmapDebug] ${dirLight.name}: lightLocal=(${dirLight.position.toArray().map(a=>a.toFixed(2))}) lightWorld=(${lightWorldPos.toArray().map(a=>a.toFixed(2))}) targetWorld=(${targetWorldPos.toArray().map(a=>a.toFixed(2))}) dirWorld=(${dirWorld.toArray().map(a=>a.toFixed(2))})`);
	}

	const shadowCam = dirLight.shadow.camera;

	shadowCam.position.copy(lightWorldPos);
	shadowCam.lookAt(targetWorldPos);
	shadowCam.updateMatrixWorld();
	const lightViewMatrix = shadowCam.matrixWorldInverse;

	let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity, minZ = Infinity, maxZ = -Infinity;
	worldCorners.forEach(corner => {
		const projected = corner.clone().applyMatrix4(lightViewMatrix);
		minX = Math.min(minX, projected.x); maxX = Math.max(maxX, projected.x);
		minY = Math.min(minY, projected.y); maxY = Math.max(maxY, projected.y);
		minZ = Math.min(minZ, projected.z); maxZ = Math.max(maxZ, projected.z);
	});

	if (isFinite(minX)) { // Check if calculation was valid
		shadowCam.left = minX - padding;
		shadowCam.right = maxX + padding;
		shadowCam.bottom = minY - padding;
		shadowCam.top = maxY + padding;
		shadowCam.near = -maxZ - padding * 2; // More padding for near/far often good
		shadowCam.far = -minZ + padding * 2;
			// Clamp near plane to be at least a small positive value
			shadowCam.near = Math.max(0.1, shadowCam.near);
		shadowCam.updateProjectionMatrix();
	} else {
		console.warn(`Could not calculate shadow bounds for light:`, dirLight);
	}
}